'use client';

import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { DAY_LABELS, DAY_SHORT } from '@/lib/curriculum';

interface DayTabsProps {
  activeDay: number;
  onSelectDay: (day: number) => void;
  daysComplete: [boolean, boolean, boolean, boolean, boolean];
}

export default function DayTabs({ activeDay, onSelectDay, daysComplete }: DayTabsProps) {
  return (
    <div
      style={{
        display: 'flex',
        gap: '4px',
        backgroundColor: 'var(--bg-card)',
        border: '1px solid var(--border)',
        borderRadius: '10px',
        padding: '4px',
      }}
      role="tablist"
      aria-label="Day tabs"
    >
      {DAY_SHORT.map((short, idx) => {
        const isActive = activeDay === idx;
        const done = daysComplete[idx];
        return (
          <button
            key={`day-tab-${idx}`}
            role="tab"
            aria-selected={isActive}
            aria-label={DAY_LABELS[idx]}
            onClick={() => onSelectDay(idx)}
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '3px',
              padding: '8px 4px',
              borderRadius: '7px',
              border: 'none',
              backgroundColor: isActive
                ? done
                  ? 'var(--accent-glow)'
                  : 'var(--bg-elevated)' :'transparent',
              cursor: 'pointer',
              transition: 'all 150ms ease',
              outline: 'none',
            }}
          >
            <span
              style={{
                fontSize: '11px',
                fontFamily: 'IBM Plex Mono, monospace',
                fontWeight: 600,
                letterSpacing: '0.04em',
                color: isActive
                  ? done
                    ? 'var(--accent)'
                    : 'var(--text-primary)'
                  : done
                    ? 'var(--accent)'
                    : 'var(--text-muted)',
              }}
            >
              {short.toUpperCase()}
            </span>
            {done ? (
              <CheckCircle2 size={12} style={{ color: 'var(--accent)' }} />
            ) : (
              <div
                style={{
                  width: '4px',
                  height: '4px',
                  borderRadius: '50%',
                  backgroundColor: isActive ? 'var(--accent)' : 'var(--text-muted)',
                  opacity: isActive ? 1 : 0.4,
                }}
              />
            )}
          </button>
        );
      })}
    </div>
  );
}